import { Paper as PaperMui } from '@mui/material';
import { styled } from '@mui/system';
import { Container, Item } from 'Components/Grid';
import * as React from 'react';

import type { PaperProps } from '@mui/material';
import type { Theme } from '@mui/material/styles';

const Header = styled(Container, { shouldForwardProp: prop => prop !== 'padding' })(
  ({ theme, padding }: { theme?: Theme; padding: number }) => ({
    backgroundColor: theme?.palette.primary.main,
    color: theme?.palette.common.white,
    padding: `1rem ${padding}rem`,
    height: '6.5rem',
    boxSizing: 'border-box' as const,
    borderTopLeftRadius: 'inherit',
    borderTopRightRadius: 'inherit',
  }),
);

const Body = styled('div', { shouldForwardProp: prop => prop !== 'padding' })(({ padding }: { padding: number }) => ({
  padding: `${padding}rem`,
}));

export const HeaderComponent = ({ padding, header }: { padding: number; header: React.JSX.Element }) => (
  <Header padding={padding} alignItems="center">
    <Item>
      <h2 style={{ margin: 0 }}>{header}</h2>
    </Item>
  </Header>
);

/**
 * Paper component for new UI components
 */
const Paper = ({ header, padding = 3.5, square = false, elevation = 2, children, ...props }: IPaper) => {
  return (
    <PaperMui square={square} elevation={elevation} {...props}>
      {header && <HeaderComponent padding={padding} header={header} />}
      <Body padding={padding}>{children}</Body>
    </PaperMui>
  );
};

interface IPaper extends PaperProps {
  header?: React.JSX.Element;
  /** Paper padding in rems */
  padding?: number;
  square?: boolean;
  elevation?: number;

  children?: React.JSX.Element | null | false | React.ReactNode | Array<React.JSX.Element | null | false>;
}

export default Paper;
